/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { IDataConnectorConfigRaw } from '@forge/data-connector';
import { createContext } from 'react';
import {
  IEMaaSContext,
  IUtiltityAccountResponse,
  toastMessageTypes
} from '../components/DashboardKPIWidgets/IEnergyManagementProps';

const connectorConfig = {
  'utility-electricity': {
    type: 'restful',
    url: 'sample/url/5'
  },
  'Co2-carbonEmission': {
    type: 'restful',
    url: 'sample/url/5'
  },
  'energyUsage-portfolio': {
    type: 'restful',
    url: 'sample/url/7'
  },
  'all-utility': {
    type: 'restful',
    url: 'sample/url/3'
  }
};

const ApiConfig = {
  defaults: {
    connectorConfig: connectorConfig,
    onServicesViewClick: function(route: string): void {
      // Initializing an empty function
    },
    onViewDetailsClick: function(route: string, utilityIndex?: number): void {
      // Initializing an empty function
    },
    onViewDetailsTabChange: function(activeIndex: number): void {
      // Initializing an empty function
    },
    ActiveIndex: 0,
    onAddServiceResponse: function(
      responseData: IUtiltityAccountResponse
    ): void {
      // Initializing an empty function
    },
    onAddServiceDoneClick: function(): void {
      // Initializing an empty function
    },
    onTemplateDownloadClick: function(
      selctedType: string,
      fileName: string,
      uploadType: string
    ): void {
      // Initializing an empty function
    },
    onNewTemplateDownloadClick: function(
      selctedType: string,
      fileName: string,
      uploadType: string
    ): void {
      // Initializing an empty function
    },
    OnUploadClick: function(
      fileList: File[],
      selectedType: string,
      uploadType: string
    ): void {
      // Initializing an empty function
    },
    getCsvHeaders: function(uploadType: string): Promise<string[]> {
      // Initializing an empty function
      return Promise.resolve([]);
    },
    onSiteEnergyUsageCardClick: function(): void {
      // Initializing an empty function
    },
    onUtilityBillViewDetailsClick: function(): void {
      // Initializing an empty function
    },
    onEnergyUsageSiteClick: function(clickedSiteId: string): void {
      // Initializing an empty function
    },
    onCarbonTabClick: function(): void {
      // Initializing an empty function
    },
    onBacktoDashboardClick: function(isFromSmp?: boolean): void {
      // Initializing an empty function
    },
    onCarbonViewDetailsClick: function(): void {
      // Initializing an empty function
    },
    onEnergyUsageViewDetailsClick: function(): void {
      // Initializing an empty function
    },
    redirect: function(redirectUrl: string): void {
      // Initializing an empty function
    },
    onPortfolioSiteClick: function(siteId: string): void {
      // Initializing an empty function
    },
    notifyMessage: function(message: string, type?: toastMessageTypes): void {
      // Initializing an empty function
    },
    siteName: '',
    preferredEuiUnit: '',
    userPreferedUnit: '',
    selectedDateFormat: '',
    selectedTimeFormat: '',
    isEOSubscribed: false,
    totalFootprint: '',
    MultilabelBreakdown: false,
    organizationName: '',
    isBreakdownEquipment: false,
    previousName: false,
    isFromSmartPower: false
  }
};

interface IAPIContext extends IEMaaSContext {
  connectorConfig?: IDataConnectorConfigRaw;
}
const updateApiConfig = (context: IAPIContext) => {
  return {
    connectorConfig: context.connectorConfig ?? connectorConfig,
    onViewDetailsClick: context.onViewDetailsClick,
    ActiveIndex: context.ActiveIndex ?? 0,
    onServicesViewClick: context.onServicesViewClick,
    onViewDetailsTabChange: context.onViewDetailsTabChange,
    onAddServiceResponse: context.onAddServiceResponse,
    onAddServiceDoneClick: context.onAddServiceDoneClick,
    onTemplateDownloadClick: context.onTemplateDownloadClick,
    onNewTemplateDownloadClick: context.onNewTemplateDownloadClick,
    OnUploadClick: context.OnUploadClick,
    getCsvHeaders: context.getCsvHeaders,
    createBulkSpatialElements: context.createBulkSpatialElements,
    updatePropertiesOfElements: context.updatePropertiesOfElements,
    handleAssociation: context.handleAssociation,
    onSiteEnergyUsageCardClick: context.onSiteEnergyUsageCardClick,
    onUtilityBillViewDetailsClick: context.onUtilityBillViewDetailsClick,
    onCarbonViewDetailsClick: context.onCarbonViewDetailsClick,
    onEnergyUsageSiteClick: context.onEnergyUsageSiteClick,
    onCarbonTabClick: context.onCarbonTabClick,
    onBacktoDashboardClick: context.onBacktoDashboardClick,
    onEnergyUsageViewDetailsClick: context.onEnergyUsageViewDetailsClick,
    onEnergyOptimizationViewDetailsClick:
      context.onEnergyOptimizationViewDetailsClick,
    onPortfolioSiteClick: context.onPortfolioSiteClick,
    redirect: context.redirect,
    notifyMessage: context.notifyMessage,
    siteName: context.siteName,
    preferredEuiUnit: context.preferredEuiUnit,
    userPreferedUnit: context.userPreferedUnit,
    selectedDateFormat: context.selectedDateFormat,
    selectedTimeFormat: context.selectedTimeFormat,
    apiCallAt: context.apiCallAt,
    totalFootprint: context.totalFootprint,
    MultilabelBreakdown: context.MultilabelBreakdown,
    organizationName: context.organizationName,
    isEOSubscribed: context.isEOSubscribed,
    currencyCode: context.currencyCode,
    isScopeFilterEnabled: context.isScopeFilterEnabled,
    isBreakdownEquipment: context.isBreakdownEquipment,
    toggleFeatureScopeOne: context.toggleFeatureScopeOne,
    onEnergyStarViewDetailsClick: context.onEnergyStarViewDetailsClick,
    showEnergyStarWidget: context.showEnergyStarWidget,
    getPropertyTemplates: context.getPropertyTemplates,
    uuid: context.uuid,
    viewcreatedMeter: context.viewcreatedMeter,
    graphType: context.graphType,
    utilityGraphType: context.utilityGraphType,
    getSiteDataForAssociationValidation:
      context.getSiteDataForAssociationValidation,
    onClickGotoSiteHomePage: context.onClickGotoSiteHomePage,
    previousName: context.previousName,
    hideHeader: context.hideHeader,
    toggleUtilityBreakdownVisualization:
      context.toggleUtilityBreakdownVisualization,
    handlePDFDownload: context.handlePDFDownload,
    onViewChange: context.onViewChange,
    siteId: context.siteId,
    onManageBill: context.onManageBill,
    onManageTariffDetails: context.onManageTariffDetails,
    onEditBill: context.onEditBill,
    setIsManageBill: context.setIsManageBill,
    setIsManageTariffDetails: context.setIsManageTariffDetails,
    setUtilityCellData: context.setUtilityCellData,
    getBillDetails: context.getBillDetails,
    manageBillPdfDownload: context.manageBillPdfDownload,
    saveDillDetails: context.saveDillDetails,
    onClickViewDetailsMeterTrend: context.onClickViewDetailsMeterTrend,
    enableViewDetailsMeterTrend: context.enableViewDetailsMeterTrend,
    utilityBuilderManualToAutomaticToggle:
      context.utilityBuilderManualToAutomaticToggle,
    isEditAllowed: context.isEditAllowed,
    UtilityTariffDetailsToggle: context.UtilityTariffDetailsToggle,
    onPublishPointHistoryMeterData: context.onPublishPointHistoryMeterData,
    onDeleteMeterDataFile: context.onDeleteMeterDataFile,
    submitFileForChunkedUpload: context.submitFileForChunkedUpload,
    progressTrackingList: context.progressTrackingList,
    toggleGasManageBill: context.toggleGasManageBill,
    toggleManualWaterSewer: context.toggleManualWaterSewer,
    toggleManualWater: context.toggleManualWater,
    toggleManageTariffDetails: context.toggleManageTariffDetails,
    toggleEditManualAccount: context.toggleEditManualAccount,
    getMeterKpiFlag: context.getMeterKpiFlag,
    submitbaselinetrainingform: context.submitbaselinetrainingform,
    getBaselineTrainedData: context.getBaselineTrainedData,
    isFromSmartPower: context.isFromSmartPower,
    refreshMeterKpi: context.refreshMeterKpi,
    getParamsFromPDF: context.getParamsFromPDF,
    ocrManageBill: context.ocrManageBill,
    totalFootPrintNativeUnit: context.totalFootPrintNativeUnit,
    pointHistoryUploadToggle: context.pointHistoryUploadToggle,
    energyUsageMultipleCalls: context.energyUsageMultipleCalls,
    setActiveIndexForUtility: context.setActiveIndexForUtility,
    setBasicAdvancedGrp: context.setBasicAdvancedGrp,
    basicAdvancedGrp: context.basicAdvancedGrp,
    setMonthlyBillingGrp: context.setMonthlyBillingGrp,
    monthlyBillingGrp: context.monthlyBillingGrp,
    overviewSet: context.overviewSet,
    overViewElectricity: context.overViewElectricity,
    isMonthlyElectricity: context.isMonthlyElectricity,
    setIsMonthlyElectricity: context.setIsMonthlyElectricity,
    utilityBillBaselineActionClick: context.utilityBillBaselineActionClick,
    enableWaterUsageDashboards: context.enableWaterUsageDashboards,
    convertToAutomaticForGas: context.convertToAutomaticForGas,
    toggleAutomaticBillCategories: context.toggleAutomaticBillCategories,
    getCurrentPage: context.getCurrentPage,
    getCurrentPageInfinite: context.getCurrentPageInfinite,
    MAX_METERS_COUNT: context.MAX_METERS_COUNT,
    toggleUtilityLevelIBO: context.toggleUtilityLevelIBO,
    toggleEnableEoTable: context.toggleEnableEoTable,
    onEOUtilityTabChange: context.onEOUtilityTabChange,
    eoAvailableTabs: context.eoAvailableTabs,
    showChangeWhenData: context.showChangeWhenData,
    triggerDateChange: context.triggerDateChange,
    getNextMetersData: context.getNextMetersData,
    toggleSeparateApi: context.toggleSeparateApi,
    getEnergyUsageTableData: context.getEnergyUsageTableData,
    getPortfolioEnergyTableData: context.getPortfolioEnergyTableData,
    enableConsumptionSourceSelect: context.enableConsumptionSourceSelect,
    cemsEnableCarbonSourceSelect: context.cemsEnableCarbonSourceSelect,
    dataSourceType: context.dataSourceType,
    setDataSourceType: context.setDataSourceType,
    toggleMultipleUploadUtility: context.toggleMultipleUploadUtility,
    getParamsFromPDFForMultipleUpload:
      context.getParamsFromPDFForMultipleUpload,
    enableInfiniteScrollSubmeterKpi: context.enableInfiniteScrollSubmeterKpi,
    enableAutomaticEditAccount: context.enableAutomaticEditAccount,
    submeterKpiSelectedPeriodCons: context.submeterKpiSelectedPeriodCons,
    getTableData: context.getTableData,
    enableZLODataUpload: context.enableZLODataUpload,
    toggleUtilityBillBreakdownPerformance:
      context.toggleUtilityBillBreakdownPerformance,
    getUtilityGraphData: context.getUtilityGraphData,
    getUtilityAccountNumbers: context.getUtilityAccountNumbers,
    disableDateApply: context.disableDateApply,
    cemsIntervalEnergySourceOption: context.cemsIntervalEnergySourceOption,
    enableIDSEnrollment: context.enableIDSEnrollment,
    eoStatus: context.eoStatus,
    toggleEnableEoStatus: context.toggleEnableEoStatus,
    saveEOStatusRuntime: context.saveEOStatusRuntime,
    eoStatusRuntime: context.eoStatusRuntime,
    toggleEnableKwhGas: context.toggleEnableKwhGas,
    toggleOpportunityFromEO: context.toggleOpportunityFromEO,
    lastUpdated: context.lastUpdated,
    isStatusCompleted: context.isStatusCompleted,
    saveEoOperationalTime: context.saveEoOperationalTime,
    eoOperationalTime: context.eoOperationalTime,
    eoActiveHours: context.eoActiveHours,
    reasonForOff: context.reasonForOff,
    userSelectedTemperatureUnit: context.userSelectedTemperatureUnit
  };
};
const ApiContext = createContext<IAPIContext>(ApiConfig.defaults);

const ContextProvider = ApiContext.Provider;
const ContextConsumer = ApiContext.Consumer;

export { ApiContext, ContextProvider, ContextConsumer, updateApiConfig };
